// ImpersonationBanner - Shows when admin is viewing as another user

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './ImpersonationBanner.module.css';

export function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !user) return null;

  const handleReturn = async () => {
    await stopImpersonating();
    navigate('/dashboard');
  };

  return (
    <div className={styles.banner}>
      <span className={styles.text}>
        Viewing as: <strong>{user.name}</strong> ({user.email})
      </span>
      <button className={styles.returnButton} onClick={handleReturn} type="button">
        Return to Admin
      </button>
    </div>
  );
}
